import PortfolioPageLayout from "../PortfolioPageLayout";
import soonaData from "../Soona/soonaData";

function Soona() {
  return <PortfolioPageLayout {...soonaData} />;
}

export default Soona;
